import { reatomBoolean } from '@reatom/framework'
import { withLocalStorage } from '@reatom/persist-web-storage'

import { STORAGE_PREFIX } from '@root/shared'
import { reatomTemporalDistinct } from '@root/shared/lib'

import type { Order } from '@blade/std-lib'
import type { Atom } from '@reatom/framework'

const STORAGE_KEY = `${STORAGE_PREFIX}/v1/isFlashDistinctEnabled`

export const isFlashTemporalDistinctEnabledAtom = reatomBoolean(
  true,
  'isFlashTemporalDistinctEnabledAtom',
).pipe(withLocalStorage(STORAGE_KEY))

type TemporalDistinctArgs<T> = {
  milliseconds?: number
  order: Order.Order<T>
}

export const reatomFlashTemporalDistinct = <T>(
  valueAtom: Atom<T>,
  options: TemporalDistinctArgs<T>,
) => {
  // eslint-disable-next-line @reatom/unit-naming-rule
  return reatomTemporalDistinct(valueAtom, {
    ...options,
    isEnabled: isFlashTemporalDistinctEnabledAtom,
  })
}
